import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { updateBook } from 'api/auth.api';

export const useUpdateBook = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: updateBook,

    onSuccess: (res) => {
      toast({
        title: 'Book Updated',
        description: res?.data?.message || 'Updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to update book',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
